const isWithin = (pathname: string, route: string) =>
  pathname === route || pathname.startsWith(`${route}/`);

/**
 * The page the open route belongs to: the one whose route is the longest start of it. What is
 * opened from a page, such as a survey from the overview, belongs to that page.
 */
export const currentPage = <T extends { route: string }>(
  pages: T[],
  pathname: string,
) =>
  pages
    .filter((page) => isWithin(pathname, page.route))
    .reduce<T | null>(
      (best, page) =>
        !best || page.route.length > best.route.length ? page : best,
      null,
    );
